module.exports = __webpack_public_path__ + "static/media/CA-2.0a9bc07e.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/CA-2.png
// module id = 196
// module chunks = 0